/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BancaDTO } from './BancaDTO';
import {
    BancaDTOFromJSON,
    BancaDTOFromJSONTyped,
    BancaDTOToJSON,
} from './BancaDTO';

/**
 * 
 * @export
 * @interface FornitoreDTO
 */
export interface FornitoreDTO {
    /**
     * 
     * @type {number}
     * @memberof FornitoreDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FornitoreDTO
     */
    ragioneSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FornitoreDTO
     */
    cognome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FornitoreDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FornitoreDTO
     */
    indirizzo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FornitoreDTO
     */
    numeroCivico?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FornitoreDTO
     */
    cap?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FornitoreDTO
     */
    localita?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FornitoreDTO
     */
    provincia?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FornitoreDTO
     */
    idNazione?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FornitoreDTO
     */
    partitaIva?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FornitoreDTO
     */
    codiceFiscale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FornitoreDTO
     */
    sdi?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FornitoreDTO
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FornitoreDTO
     */
    attivo?: boolean;
    /**
     * 
     * @type {BancaDTO}
     * @memberof FornitoreDTO
     */
    banca?: BancaDTO;
}

/**
 * Check if a given object implements the FornitoreDTO interface.
 */
export function instanceOfFornitoreDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FornitoreDTOFromJSON(json: any): FornitoreDTO {
    return FornitoreDTOFromJSONTyped(json, false);
}

export function FornitoreDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FornitoreDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'ragioneSociale': !exists(json, 'ragioneSociale') ? undefined : json['ragioneSociale'],
        'cognome': !exists(json, 'cognome') ? undefined : json['cognome'],
        'nome': !exists(json, 'nome') ? undefined : json['nome'],
        'indirizzo': !exists(json, 'indirizzo') ? undefined : json['indirizzo'],
        'numeroCivico': !exists(json, 'numeroCivico') ? undefined : json['numeroCivico'],
        'cap': !exists(json, 'cap') ? undefined : json['cap'],
        'localita': !exists(json, 'localita') ? undefined : json['localita'],
        'provincia': !exists(json, 'provincia') ? undefined : json['provincia'],
        'idNazione': !exists(json, 'idNazione') ? undefined : json['idNazione'],
        'partitaIva': !exists(json, 'partitaIva') ? undefined : json['partitaIva'],
        'codiceFiscale': !exists(json, 'codiceFiscale') ? undefined : json['codiceFiscale'],
        'sdi': !exists(json, 'sdi') ? undefined : json['sdi'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'attivo': !exists(json, 'attivo') ? undefined : json['attivo'],
        'banca': !exists(json, 'banca') ? undefined : BancaDTOFromJSON(json['banca']),
    };
}

export function FornitoreDTOToJSON(value?: FornitoreDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'ragioneSociale': value.ragioneSociale,
        'cognome': value.cognome,
        'nome': value.nome,
        'indirizzo': value.indirizzo,
        'numeroCivico': value.numeroCivico,
        'cap': value.cap,
        'localita': value.localita,
        'provincia': value.provincia,
        'idNazione': value.idNazione,
        'partitaIva': value.partitaIva,
        'codiceFiscale': value.codiceFiscale,
        'sdi': value.sdi,
        'email': value.email,
        'attivo': value.attivo,
        'banca': BancaDTOToJSON(value.banca),
    };
}

